<template>
  <b-form @submit.prevent="setChartConfig">
    <b-card v-if="settingType === 'AS'" class="border0" body-class="grpHd anal">
      <b-row>
        <b-col class="col-6">
          <label class="head">ANAL_1</label>
          <b-form-input
            type="number"
            v-model="analstanal1"
            :max="analedanal1"
          ></b-form-input>
          <label>~</label>
          <b-form-input
            type="number"
            v-model="analedanal1"
            :min="analstanal1"
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">ANAL_2</label>
          <b-form-input
            type="number"
            v-model="analstanal2"
            :max="analedanal2"
          ></b-form-input>
          <label>~</label>
          <b-form-input
            type="number"
            v-model="analedanal2"
            :min="analstanal2"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label class="head">온도</label>
          <b-form-input
            type="number"
            v-model="analsttemp"
            :max="analedtemp"
          ></b-form-input>
          <label>~</label>
          <b-form-input
            type="number"
            v-model="analedtemp"
            :min="analsttemp"
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">습도</label>
          <b-form-input
            type="number"
            v-model="analsthumid"
            :max="analedhumid"
          ></b-form-input>
          <label>~</label>
          <b-form-input
            type="number"
            v-model="analedhumid"
            :min="analsthumid"
          ></b-form-input>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="settingType === 'RF'" class="border0" body-class="grpHd rawe">
      <b-row>
        <b-col class="col-6">
          <label class="head">Trigger-event</label>
          <b-form-input
            type="number"
            v-model="rawestchart1"
            :max="raweedchart1"
          ></b-form-input>
          <label>~</label>
          <b-form-input
            type="number"
            v-model="raweedchart1"
            :min="rawestchart1"
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">Averaged Freq</label>
          <b-form-input
            type="number"
            v-model="rawestchart2"
            :max="raweedchart2"
          ></b-form-input>
          <label>~</label>
          <b-form-input
            type="number"
            v-model="raweedchart2"
            :min="rawestchart2"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label class="head">Main Freq</label>
          <b-form-input
            type="number"
            v-model="rawestchart3"
            :max="raweedchart3"
          ></b-form-input>
          <label>~</label>
          <b-form-input
            type="number"
            v-model="raweedchart3"
            :min="rawestchart3"
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">Change of Cluster</label>
          <b-form-input
            type="number"
            v-model="rawestchart4"
            :max="raweedchart4"
          ></b-form-input>
          <label>~</label>
          <b-form-input
            type="number"
            v-model="raweedchart4"
            :min="rawestchart4"
          ></b-form-input>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="settingType === 'AS'" class="border0" body-class="grpHd s-v">
      <b-row>
        <b-col class="col-6">
          <label class="head">S-V</label>
          <b-form-input
            type="number"
            v-model="svstsv"
            :max="svedsv"
          ></b-form-input>
          <label>~</label>
          <b-form-input
            type="number"
            v-model="svedsv"
            :min="svstsv"
          ></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">온도</label>
          <b-form-input
            type="number"
            v-model="svsttemp"
            :max="svedtemp"
          ></b-form-input>
          <label>~</label>
          <b-form-input
            type="number"
            v-model="svedtemp"
            :min="svsttemp"
          ></b-form-input>
        </b-col>
      </b-row>
    </b-card>
    <div class="btnGrp">
      <div class="jcse">
        <b-button class="empty-modBtn" type="submit"
          ><i class="fa fa-edit"></i>저장</b-button
        >
        <!-- <b-button v-else class="chgBtn" type="submit"><i class="fa fa-edit"></i>변경</b-button> -->
        <b-button class="empty-delBtn mr0" @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </b-form>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters(["getUserId", "getAlertOptions", "getConfirmOptions"]),
  },
  props: {
    settingType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      analstanal1: null,
      analedanal1: null,
      analstanal2: null,
      analedanal2: null,
      analsttemp: null,
      analedtemp: null,
      analsthumid: null,
      analedhumid: null,
      rawestchart1: null,
      raweedchart1: null,
      rawestchart2: null,
      raweedchart2: null,
      rawestchart3: null,
      raweedchart3: null,
      rawestchart4: null,
      raweedchart4: null,
      svstsv: null,
      svedsv: null,
      svsttemp: null,
      svedtemp: null,
    };
  },
  created() {
    // this.getDefaultCodes()
    this.getChartConfig();
  },
  beforeMount() {},
  mounted() {},
  destroyed() {},
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    setChartConfig() {
      var reqBody = null;
      if (this.settingType === "AS") {
        reqBody = {
          settingtype: this.settingType,
          analstanal1: this.analstanal1,
          analedanal1: this.analedanal1,
          analstanal2: this.analstanal2,
          analedanal2: this.analedanal2,
          analsttemp: this.analsttemp,
          analedtemp: this.analedtemp,
          analsthumid: this.analsthumid,
          analedhumid: this.analedhumid,
          svstsv: this.svstsv,
          svedsv: this.svedsv,
          svsttemp: this.svsttemp,
          svedtemp: this.svedtemp,
        };
      } else {
        reqBody = {
          settingtype: this.settingType,
          rawestchart1: this.rawestchart1,
          raweedchart1: this.raweedchart1,
          rawestchart2: this.rawestchart2,
          raweedchart2: this.raweedchart2,
          rawestchart3: this.rawestchart3,
          raweedchart3: this.raweedchart3,
          rawestchart4: this.rawestchart4,
          raweedchart4: this.raweedchart4,
        };
      }
      this.$http
        .post("/sensor/setSensorChartConfig", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.setAlertTitle("설정 완료");
            this.$bvModal
              .msgBoxOk(
                "Scale 범위 설정이 완료되었습니다.",
                this.getAlertOptions
              )
              .then((value) => {
                this.closeModal();
                this.$emit("researchChartConfig");
                this.$emit("researchChartData");
              })
              .catch((err) => {
                console.error(err);
              });
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getChartConfig() {
      var reqBody = {
        settingtype: this.settingType,
      };
      this.$http
        .post("/sensor/getSensorChartConfig", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let config = res.data.data;
            for (let key in config) {
              if (key !== "userid") {
                this[key] = config[key];
              }
            }
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    closeModal() {
      this.$bvModal.hide("sensorDataChartSettingModal");
    },
  },
};
</script>

<style lang="scss">
#sensorDataChartSettingModal .modal-dialog {
  max-width: 950px;
  & .modal-content {
    & .card {
      padding: 0 30px 30px;
      & .card-body {
        border: 1px solid #7367f0;
        border-radius: 8px;
        & .row .col {
          & label {
            display: flex;
            align-items: center;
            height: 100%;
            padding-bottom: 1px;
            width: auto;
            margin: 0 15px;
            &.head {
              width: 120px;
              margin: 0 10px 0 0;
            }
          }
          & input,
          & select {
            width: 120px;
          }
        }
        &.grpHd {
          &::before {
            display: block;
            position: absolute;
            top: -15px;
            left: 50px;
            font-size: 16px;
            font-weight: 600;
            border: 1px solid #7367f0;
            border-radius: 10px;
            color: #b4b7bd;
            background: #283046;
            padding: 1px 10px 3px;
            letter-spacing: 1px;
          }
          &.anal::before {
            content: "ANAL";
          }
          &.rawe::before {
            content: "RAWE";
          }
          &.s-v::before {
            content: "S-V";
          }
          &.file::before {
            content: "FILE";
          }
        }
      }
      &:first-child {
        margin-top: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/SensorDataSettingModal.vue